<script setup>
import {
  ref,
  onBeforeMount,
  computed,
  onMounted } from "vue";
import { useCompanyStore } from "@/stores/company";
import { useAreasStore } from "@/stores/areas";
import { useUiStore } from "@/stores/ui";
import "leaflet/dist/leaflet.css";
// import * as L from 'leaflet';
// import 'leaflet.markercluster/dist/MarkerCluster.css';
// import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
// import "leaflet.markercluster";
// import 'leaflet-geosearch/dist/geosearch.css';

// import icon from '@/assets/images/location_icon.png'
// const markers = L.markerClusterGroup();

const props = defineProps({
  storesOptions: Array,
});

const areasStore = useAreasStore();
const uiStore = useUiStore();
const emit = defineEmits(["refresh"]);
const company_id = useCompanyStore().companyId;
const storeObj = ref(null);
const parent_location = ref(null);
let parentLocations = ref([]);
let description = ref(null);
let name = ref(null);
let latitude = ref(null);
let longitude = ref(null);
let isSubmitted = ref(false);
let isLoadingParentLocations = ref(false);
const getModalInfo = computed(() => uiStore.modalData);
const getModalAction = computed(() => uiStore.modalAction);
// import * as GeoSearch from 'leaflet-geosearch';

let addFromStoresActions = ref(false);
// const initialMap = ref(null);

// const myIcon = L.icon({
//   iconUrl: icon,
//   iconSize: [30, 30],
//   iconAnchor: [15, 30],
//   popupAnchor: [-3, -76],
//   shadowSize: [60, 30],
//   shadowAnchor: [22, 94]
// });

const changeStoreVal = () => {
  parent_location.value = null;
  parentLocations.value = [];
  if (storeObj.value) {
    isLoadingParentLocations.value = true;
    areasStore
      .fetchParentAreas({
        siteId: storeObj.value,
        companyId: company_id,
      })
      .then(() => {
        //        parentLocations.value = res.data;
        isLoadingParentLocations.value = false;
      });
  }
};

const resetData = () => {
  storeObj.value = null;
  name.value = null;
  latitude.value = null;
  longitude.value = null;
  description.value = null;
  parent_location.value = null;
  parentLocations.value = [];
  isLoadingParentLocations.value = false;
  isSubmitted.value = false;
};

const onSubmit = () => {
  isSubmitted.value = true;
  const data = {
    name: name.value,
    // latitude : latitude.value.toString(),
    // longitude : longitude.value.toString(),
    description: description.value,
    site_id: storeObj.value,
    parent_id: parent_location.value,
    company_id,
  };

  areasStore
    .addArea(data)
    .then(() => {
      isSubmitted.value = false;
      resetStoreData();
      resetData();
      emit("refresh");
    })
    .catch(() => {
      isSubmitted.value = false;
    });
};

const resetStoreData = () => {
  uiStore.resetModalStore();
};

// const pickLocation = (e) => {
//
//   let marker = new L.marker([e.latlng.lat , e.latlng.lng], {icon: myIcon})
//   .bindTooltip(`lat: ${e.latlng.lat} <br> long: ${e.latlng.lng}`)
//   .bindPopup(`lat: ${e.latlng.lat} <br> long: ${e.latlng.lng}`)
//   .addTo(initialMap.value);

//   markers.addLayer(marker);
//   initialMap.value.addLayer(markers);

//   initialMap.value.latLngToLayerPoint(marker.getLatLng());

//   latitude.value = e.latlng.lat;
//   longitude.value = e.latlng.lng;
// }

onMounted(() => {
  if (
    getModalAction.value == "add_location" ||
    getModalAction.value == "add_location_with_site"
  ) {
    // setTimeout(() => {
    //   initialMap.value = L.map('mapArea', {zoomControl: true,zoom:1,zoomAnimation:false,fadeAnimation:true,markerZoomAnimation:true}).setView([0, 0], 15);
    //   const search = new GeoSearch.GeoSearchControl({
    //     provider: new GeoSearch.OpenStreetMapProvider(),
    //   });
    //   initialMap.value.addControl(search);
    //   navigator.geolocation.getCurrentPosition(function (position) {
    //     var latitude = position.coords.latitude;
    //     var longitude = position.coords.longitude;
    //     // Center the map on the user's location
    //     initialMap.value.setView([latitude, longitude], 15);
    //   }, (error) => { // location access denied
    //       console.error('Error getting user location:', error);
    //   });
    //   initialMap.value.on('click', pickLocation);
    //   L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //     maxZoom: 19,
    //   }).addTo(initialMap.value);
    // },500);
  }
});

onBeforeMount(() => {
  if (getModalInfo.value && getModalAction.value == "add_location_with_site") {
    addFromStoresActions.value = true;
    props.storesOptions.map((obj) => {
      if (obj.id == getModalInfo.value.id) {
        storeObj.value = obj.id;
      }
    });

    areasStore
      .fetchParentAreas({
        siteId: storeObj.value,
        companyId: company_id,
      })
      .then(() => {
        //        parentLocations.value = res.data;
        isLoadingParentLocations.value = false;
      });
  }
});
</script>

<template>
  <DModal v-if="['add_location', 'add_location_with_site'].includes(getModalAction)" :visible="uiStore.modalState" @update:visible="val => { if (!val) resetStoreData() }" :main_classes="[]" :dialog_classes="[]">
    <template #title> Add New Location </template>

    <template #body>
      <!-- <div class="mb-3">
        <span class="map-hint">Please pick up the area location on the map</span>
      </div> -->

      <!-- <div class="map-card p-0 mb-3">
        <div id="mapArea" style="height:34vh;"></div>
      </div> -->

      <!-- <div class="relative mb-3">
        <span v-if="storeObj" class="multiselect-title-span">Site</span>
        <VMultiselect
          @select="changeStoreVal"
          @remove="changeStoreVal"
          v-model="storeObj"
          :options="props.storesOptions"
          :disabled="!props.storesOptions.length"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Site"
          trackBy="id"
          label="name"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="storeObj"
          inputId="storeObj"
          :options="props.storesOptions"
          :disabled="!props.storesOptions.length"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          @change="changeStoreVal"
          filter
          filterPlaceholder="Search by site name"
        />
        <label for="role">Site</label>
      </FloatLabel>

      <div class="mb-3">
        <DInput :value="name" @input="name = $event.target.value" label="Location Name" width="100%" />
      </div>

      <FloatLabel class="w-full mb-3">
        <PTextarea
          v-model="description"
          id="description"
          class="d-textarea resize-none h-105 w-full"
          autoResize
        />
        <label for="description">Description</label>
      </FloatLabel>

      <!-- <div class="relative">
        <span v-if="parent_location" class="multiselect-title-span"
          >Parent Location</span
        >
        <VMultiselect
          v-model="parent_location"
          :options="parentLocations"
          trackBy="id"
          label="name"
          :disabled="!storeObj || isLoadingParentLocations"
          :loading="isLoadingParentLocations"
          :searchable="true"
          :close-on-select="true"
          :show-labels="false"
          placeholder="Parent Location"
        />
      </div> -->

      <FloatLabel class="w-full md:w-14rem mb-3">
        <PDropdown
          v-model="parent_location"
          inputId="parentLocation"
          :options="parentLocations"
          :disabled="!storeObj || isLoadingParentLocations"
          optionLabel="name"
          optionValue="id"
          class="w-full"
          filter
          filterPlaceholder="Search by location name"
        />
        <label for="parentLocation">Parent Location</label>
      </FloatLabel>
    </template>
    <template #footer>
      <div class="w-full">
        <div class="seperator text-center"></div>
        <div class="flex mt-20 justify-center">
          <button
            :disabled="!storeObj || !name || isSubmitted"
            @click="onSubmit"
            type="button"
            class="btn btn-primary add-button mr-30"
          >
            Add
            <span
              v-if="isSubmitted"
              class="spinner-sm"
              role="status"
              aria-hidden="true"
            ></span>
          </button>
          <button
            @click="resetStoreData"
            type="button"
            class="btn btn-secondary cancel-button"
          >
            Cancel
          </button>
        </div>
      </div>
    </template>
  </DModal>
</template>
